﻿window.AMWD = $.extend(window.AMWD, {
	sleep,
	urlBase64ToUint8Array,
	base64Encode,
	getFontColor,
	initOutlineBadge
});

function sleep(milliseconds) {
	return new Promise(resolve => setTimeout(resolve, milliseconds));
}

// https://github.com/mozilla/serviceworker-cookbook/blob/master/tools.js
function urlBase64ToUint8Array(base64String) {
	let padding = '='.repeat((4 - base64String.length % 4) % 4);
	let base64 = (base64String + padding)
		.replace(/-/g, '+')
		.replace(/_/g, '/');

	let raw = atob(base64);
	let array = new Uint8Array(raw.length);

	for (let i = 0; i < raw.length; ++i) {
		array[i] = raw.charCodeAt(i);
	}
	return array;
}

function base64Encode(arrayBuffer) {
	let array = new Uint8Array(arrayBuffer);
	let str = String.fromCharCode.apply(null, array);
	return btoa(str);
}

function getFontColor(backgroundColor, useAlpha) {
	if (useAlpha === undefined || useAlpha === null)
		useAlpha = false;

	let cvs = document.createElement('canvas');
	cvs.height = 1;
	cvs.width = 1;
	let ctx = cvs.getContext('2d');
	ctx.fillStyle = backgroundColor;
	ctx.fillRect(0, 0, 1, 1);
	let res = ctx.getImageData(0, 0, 1, 1).data;

	let r = Number(res[0]);
	let g = Number(res[1]);
	let b = Number(res[2]);
	let a = Number(res[3]);

	if (!useAlpha && a === 0)
		return 'rgba(0, 0, 0, 1)';

	if (!useAlpha)
		a = 1;

	if (a > 1)
		a /= 255;

	let luminance = (r * 0.299 + g * 0.587 + b * 0.114) / 255;
	if (luminance <= 0.5)
		return 'rgba(255, 255, 255, ' + a + ')';

	return 'rgba(0, 0, 0, ' + a + ')';
}

function initOutlineBadge(element) {
	if (element === undefined || element === null) {
		element = $(document).find('.badge-outline');
	}
	else {
		element = $(element);
	}

	$.each(element, (_, el) => {
		el = $(el);
		let color = el.data('color');

		el.css('color', color);
		el.css('border-color', color);

		if (el.is('a') || el.css('cursor') === 'pointer') {
			el.hover(event => {
				switch (event.type) {
					case "mouseenter":
						el.data('bg', el.css('background-color'));
						el.css('background-color', color);
						el.css('color', getFontColor(color, true));
						break;
					case "mouseleave":
						el.css('background-color', el.data('bg'));
						el.css('color', color);
						el.removeData('bg');
						break;
					default:
						console.log(event);
						break;
				}
			});
		}
	});
}
